angular.module('impactx.uploadservicebrowser').controller('ResetDialogCtrl', ['$scope', '$mdDialog', 'TranslationService', 'themeFactory',
    'header', 'inputLabel', ResetDialogCtrl]);

function ResetDialogCtrl($scope, $mdDialog, TranslationService, themeFactory, header, inputLabel)
{
    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.theme = themeFactory.getTheme();
    $scope.header = header;
    $scope.inputLabel = inputLabel;
    $scope.email = {value: ""};
    var self = this;

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.answer = function() {
        $mdDialog.hide($scope.email.value);
    };
}